import { useActivityFacets } from './use-activities';

import {
  useCatalogGeoFilters,
  useSelectedCountryId,
  type CatalogGeoFilters,
} from '@/hooks/use-catalog-geo-filters';

/**
 * Builds the Country + City list-filters shared by the Activities Listing grid
 * and the Media bulk-assign tool (which uses the Country half only). Options
 * come from the activity facets endpoint - i.e. only places actually in use by
 * activities, refreshed as new activities are added. City narrows to whatever
 * Country is selected.
 */
export function useActivityGeoFilters(): CatalogGeoFilters {
  const facets = useActivityFacets();
  return useCatalogGeoFilters(facets.data, useSelectedCountryId());
}
